import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getCheckoutContentRequest = {};
var _getCheckoutContentResponse = {};
function resolveWixEcomCheckoutContentSpiHostV1CheckoutContentSpiHostServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/ecom/v1/checkout-content',
                destPath: '/v1/checkout-content',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/ecom/v1/checkout-content',
                destPath: '/v1/checkout-content',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/ecom/v1/checkout-content',
                destPath: '/v1/checkout-content',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/ecom/v1/checkout-content',
                destPath: '/v1/checkout-content',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/ecom/v1/checkout-content',
                destPath: '/v1/checkout-content',
            },
        ],
        _: [
            {
                srcPath: '/ecom/v1/checkout-content',
                destPath: '/v1/checkout-content',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a CheckoutContent. */
export function getCheckoutContent(payload) {
    var _a = serializer(_getCheckoutContentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCheckoutContentResponse, {}).fromJSON;
    function __getCheckoutContent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.api.v1.checkout_content_provider',
            method: 'GET',
            methodFqn: 'wix.ecom.checkout_content_spi_host.v1.CheckoutContentSPIHostService.GetCheckoutContent',
            url: resolveWixEcomCheckoutContentSpiHostV1CheckoutContentSpiHostServiceUrl({
                protoPath: '/v1/checkout-content/{appId}/{componentId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCheckoutContent.fromReq = fromReq;
    __getCheckoutContent.__isAmbassador = true;
    return __getCheckoutContent;
}
//# sourceMappingURL=http.impl.js.map